<template>
  <div class="dropdown-container">
    <div class="input-dropdown" :class="{'small': isSmall, 'error': error, 'blocked': readonly}">
      <input v-model="inputContent"
             @input="content = null"
             type="text"
             class="text-input"
             :aria-label="placeholder"
             :placeholder="placeholder"
             @focus="is_focused = true"
             @blur="clearTextIfNotSelected"
             v-bind:readonly="readonly"
      />
    </div>
<!-- Temporary hidden because it hard to fit right beautifully -->
<!--    <div class="search-icon">-->
<!--      <b-icon icon="search"></b-icon>-->
<!--    </div>-->

    <div class="items-list" v-if="is_focused && (!readonly)">
      <div
        tabindex="0"
        class="item"
        v-for="item in filteredItems"
        :key="item.id"
        @mousedown.prevent="selectValue(item)"
        :class="{'multiline': multiline}"
      >
        <p>{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputDropdown",
  props: {
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    multiline: {
      type: Boolean,
      required: false,
      default: false
    },
    isSmall: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false
    },
    items: {
      type: Array,
      required: true
    },
    value: {
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      is_focused: false,
      inputContent: "",
      content: this.value
    }
  },
  methods: {
    reset() {
      this.inputContent = "";
      this.clearValue();
    },
    clearValue() {
      if (!this.content || this.inputContent !== this.content.name) {
        this.content = null;
        this.$emit('input', this.content);
      }
    },
    selectValue(value) {
      if (!value || !value.name) {
        return;
      }
      this.inputContent = value.name;
      this.content = value;
      this.is_focused = false
      this.$emit('input', this.content);
      this.$emit('change', this.content);
    },
    clearTextIfNotSelected() {
      this.is_focused = false;
      if (!this.content || this.inputContent !== this.content.name) {
        this.inputContent = "";
      }
    }
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) => item.name.toLowerCase().includes(this.inputContent.toLowerCase()));
    }
  },
  mounted () {
    this.selectValue(this.value);
  },
  watch: {
    value(newValue) {
      this.selectValue(newValue);
    }
  }
}
</script>

<style scoped>
.dropdown-container {
  margin: 0.5rem 0 1rem 0;
  width: 100%;
  position: relative;
}

.input-dropdown {
  background-color: #f4f4f4;
  color: #717171;
  width: 100%;
  height: 3rem;
  border-radius: 0.4rem;
  display: flex;
}

.text-input {
  border-radius: 0.4rem;
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  border: 1px solid #6f6f6f;
  padding-left: 1rem;
  padding-top: .4rem;
}

.text-input:focus {
  outline-color: #202f64;
}

.search-icon {
  width: 10%;
  font-size: 1.2rem;
  padding: 0.7rem 0 0 2rem;
  position: absolute;
  right: 2rem;
  cursor: pointer;
}

.items-list {
  z-index: 3;
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 10rem;
  background-color: #f4f4f4;
  border-top: 1px solid #202f64;
  overflow-y: scroll;
  box-shadow: 4px 4px 5px 0 #a2a2a2;
}

.item {
  text-transform: capitalize;
  height: 2rem;
  padding-left: 1rem;
  padding-top: .4rem;
  cursor: pointer;
}

.multiline {
  height: unset !important;
  padding-top: unset !important;
}

.item:hover {
  font-weight: bold;
}

.small {
  height: 2rem;
}

.error {
  border: 1px solid red;
}

.blocked input {
  cursor: not-allowed;
}
</style>
